var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1vw",
    height: "1vw",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8172 9.64266C15.2415 9.2891 15.2988 8.65853 14.9452 8.23425C14.5917 7.80998 13.9611 7.75265 13.5368 8.10622L14.8172 9.64266ZM10.1995 12.189L9.55931 12.9572C9.93016 13.2663 10.4688 13.2663 10.8397 12.9572L10.1995 12.189ZM6.86218 8.10622C6.4379 7.75265 5.80734 7.80998 5.45377 8.23425C5.10021 8.65853 5.15753 9.2891 5.58181 9.64266L6.86218 8.10622ZM13.5368 8.10622L9.55931 11.4208L10.8397 12.9572L14.8172 9.64266L13.5368 8.10622ZM10.8397 11.4208L6.86218 8.10622L5.58181 9.64266L9.55931 12.9572L10.8397 11.4208ZM18 10C18 14.4183 14.4183 18 10 18V20C15.5228 20 20 15.5228 20 10H18ZM10 18C5.58172 18 2 14.4183 2 10H0C0 15.5228 4.47715 20 10 20V18ZM2 10C2 5.58172 5.58172 2 10 2V0C4.47715 0 0 4.47715 0 10H2ZM10 2C14.4183 2 18 5.58172 18 10H20C20 4.47715 15.5228 0 10 0V2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/selectIcon.555d5cd87c262e9f04df732873a49e40.svg";
export { ForwardRef as ReactComponent };